// @ts-strict-ignore
import queryString from 'query-string';

import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {Annotation} from 'common/report/model-resources/annotations/types';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint({id, fromDate, toDate}: {id?: string; fromDate?: string; toDate?: string} = {}): string {
  let path = appApiUrl(`annotations/`, {projectId: getProjectId(), workspaceId: getWorkspaceId()});
  if (id) {
    path = `${path}${id}/`;
  }

  if (fromDate || toDate) {
    path += `?${queryString.stringify({fromDate, toDate})}`;
  }

  return path;
}

export type CreateAnnotationParams = Pick<Annotation, `description` | `date` | `tags`>;

export async function createAnnotation({date, description, tags}: CreateAnnotationParams): Promise<Annotation> {
  return apiClient.post(buildEndpoint(), {date, description, tags: tags.map((tag) => tag.id)});
}

export async function updateAnnotation(
  id: number,
  {description, tags}: Pick<Annotation, `description` | `tags`>,
): Promise<Annotation> {
  return apiClient.patch(buildEndpoint({id: id.toString()}), {description, tags: tags?.map((tag) => tag.id)});
}

export async function deleteAnnotation(id: number) {
  return apiClient.delete(buildEndpoint({id: id.toString()}));
}

export const annotationsClient: ApiResourceClient<TODO> = {
  index() {
    const annotationListToMap = (annotations: Annotation[] | null) => {
      if (!annotations) {
        // annotations can be null when reading from cache
        return null;
      }
      return Object.fromEntries(annotations.map((annotation) => [annotation.id, annotation]));
    };
    const {cache, network} = apiClient.hydratedGet<Annotation[]>(buildEndpoint());
    return {
      cache: cache.then(annotationListToMap),
      network: network.then(annotationListToMap),
    };
  },

  get(annotationId: string) {
    return apiClient.hydratedGet<Annotation>(buildEndpoint({id: annotationId}));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
